import { render, staticRenderFns } from "./GreatGrandChildren.vue?vue&type=template&id=a8f912be"
import script from "./GreatGrandChildren.vue?vue&type=script&lang=ts"
export * from "./GreatGrandChildren.vue?vue&type=script&lang=ts"
import style0 from "./GreatGrandChildren.vue?vue&type=style&index=0&id=a8f912be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports